import React, { Component, createRef, LegacyRef } from 'react';
import NotificationSystem, { Style, System } from 'react-notification-system';

const NotificationSystemStyle: Style = {
  NotificationItem: {
    DefaultStyle: {
      margin: '60px 5px 5px 5px',
    },
  },
};

interface Props extends JSX.ElementChildrenAttribute {
}

interface State {
  selectionNotificationSystem: LegacyRef<System>
}

export const NotificationSystemContext = React.createContext<State>({
  selectionNotificationSystem: createRef<System>()
});

export class NotificationSystemProvider extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      selectionNotificationSystem: createRef<System>()
    };
  }


  render() {
    return (
        <NotificationSystemContext.Provider value={this.state}>
          {this.props.children}
          <NotificationSystem ref={this.state.selectionNotificationSystem} style={NotificationSystemStyle}/>
        </NotificationSystemContext.Provider>
    );
  }

}

export interface NotificationSystemProps extends State {
}

export const withNotificationSystemContext = (Component: typeof React.Component | React.FunctionComponent<any>) => {
  return (props: any) => (
      <NotificationSystemContext.Consumer>
        {({...notificationSystemProps}: NotificationSystemProps) => {
          return <Component {...props} {...notificationSystemProps} />
        }}
      </NotificationSystemContext.Consumer>
  );
};
